import { signOut } from 'firebase/auth';
import { useCallback } from 'react';

import { useLogout } from './useLogout';
import { anonymousLogin, useAppDispatch } from '../state';

export function useTalkieSignOut() {
  const { onSignOut } = useLogout();
  const dispatch = useAppDispatch();
  const signOutWithFirebase = useCallback(async () => {
    const { auth } = await import('../utils/firebase');
    await signOut(auth);
    await onSignOut(false);
    await dispatch(anonymousLogin({}));
    location.href = '/create/login';
  }, [onSignOut, dispatch]);

  return {
    signOutWithFirebase,
  };
}
